// https://github.com/antoine92190/vue-advanced-chat#named-slots
import {LoadingController, NavController, Platform} from '@ionic/angular';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { RestService } from '../../services/rest.service';
import { UtilService } from '../../services/util.service';
import { register } from 'vue-advanced-chat/dist/vue-advanced-chat.es.js';
import {collection, addDoc, getDocs, getDoc, query, where, updateDoc, doc, onSnapshot, limit} from 'firebase/firestore';
import { ActivatedRoute } from '@angular/router';
import {Location} from "@angular/common";
import {VariableNavBarService} from "../../services/variable-nav-bar.service";
import {SearchLouderbandComponent} from "../../components/search-louderband/search-louderband.component";
// Pixel library importing
import { PixelService } from 'ngx-pixel';
import { environment } from 'src/environments/environment';

register();

@Component({
  selector: 'app-chat',
  templateUrl: 'chat.page.html',
  styleUrls: ['chat.page.scss'],
})

export class ChatPage implements OnInit {
  @ViewChild('appSearchLouderband') searchBar: SearchLouderbandComponent;
  public currentUserId: any;
  roomId: any;
  public rooms: any[] = [];

  public messages = [];
  public messagesLoaded = false;
  public user: any;

  public chatroom_id: any;
  public user_id: string;
  public url_message: any;
  public doc_ref: any = null;
  public docRefNotification: any = null;
  public unsub: any;

  public remoteAvatar: any;

  loadMostWanted: boolean;
  helpFocus: boolean;
  showOverSearch: boolean;
  searchTop: string;
  isMobile: boolean;
  profileID: any;
  remoteUser: any;
  avatarImg: any[] = [];


  constructor(
    public rest: RestService,
    public util: UtilService,
    public platform: Platform,
    private route: ActivatedRoute,
    public navCtrl: NavController,
    public elementRef: ElementRef,
    private locationRouter: Location,
    public loadingCtrl: LoadingController,
    private pixel: PixelService,
    public variableNavBarService: VariableNavBarService
  ) {
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.isMobile = true;
    }
    this.rest.getStorage('user').then((val) => {
      this.user = val;
      console.log('CHAT',val);
      console.log('CHAT','Setting current chat user ID...', this.user.id);
      this.currentUserId = this.user.id + '';
    });
  }

  async ngOnInit() {
    this.variableNavBarService.updateVarOnChatPage();
    const auxLoading = await this.loadingCtrl.create({});
    await auxLoading.present();

    this.loadMostWanted = true;
    this.route.params.subscribe(params => {
      this.chatroom_id = params['chatroom'];
      this.user_id = params['user'];
      this.url_message = params['message'];
    });

    if (!this.user) {
      await this.rest.getStorage('user').then((val) => {
        this.user = val;
        console.log('CHAT', val);
        console.log('CHAT', 'Setting current chat user ID...', this.user.id);
        this.currentUserId = this.user.id + '';
      });
    }

    console.log('CHAT', 'Fom Chat:', 'Entering chat: ', this.chatroom_id, this.user_id, this.url_message, this.user);

    if (this.currentUserId != this.user_id) {
      if (this.user) {
        console.log('CHAT', 'A logged user was found', this.user);

        console.log('CHAT', 'Setting current chat user ID...', this.user.id);
        this.currentUserId = this.user.id + '';

        if (this.user_id) {
          console.log('CHAT', 'A user to send a message as set with id: ', this.user_id);
          console.log('CHAT', 'Finding existing chatroom...');
          let chatroom: any = await this.findChatroom(this.user.id, this.user_id);

          if (chatroom) {
            console.log('CHAT', 'Chatroom was found', chatroom);
            this.roomId = chatroom.roomId;
          } else {
            console.log('CHAT', 'Chatroom was not found for given localUserId, remoteUserId');
            console.log('CHAT', 'Starting a new chatroom for given localUserId, remoteUserId', this.user.id, this.user_id);

            if (this.url_message) {
              let message = this.url_message;

              console.log('CHAT', 'A message was set: ', this.url_message);
              this.startChatroom(this.user, this.util.getChatTargetUser(), message);
            } else {
              this.startChatroom(this.user, this.util.getChatTargetUser(), null);
            }
          }
        } else {
          console.log('CHAT', 'Target user not set, loading rooms instead...');
          this.findChatroom(this.user.id, null);
        }

      } else {
        console.log('CHAT', 'User is not logged in, aborting...');
        alert('User is not logged in, aborting...');
      }
      await auxLoading.dismiss();
    } else {
      await auxLoading.dismiss();
      this.navCtrl.navigateForward('/mensajes');
    }
  }

  async findChatroom(localUserId, remoteUserId) {
    console.log('CHAT','Trying to find chatroom for users: ', localUserId, remoteUserId);

    const rooms = [];
    let chatrooms = await collection(this.util.db, 'chatrooms');

    const q1 = query(chatrooms, where("_id_user_local", "==", localUserId + ''));
    const q2 = query(chatrooms, where("_id_user_remote", "==", localUserId + ''));

    const querySnapshot1 = await getDocs(q1);
    const querySnapshot2 = await getDocs(q2);

    querySnapshot1.forEach((doc) => {
      console.log('CHAT','Found _id_user_local', doc.data());

      if (doc.data()._id_user_remote == remoteUserId) {
        this.setCurrentChat(doc);
      }

      rooms.push(doc.data());
    });

    querySnapshot2.forEach((doc) => {
      console.log('CHAT','Found _id_user_remote', doc.data());

      if (doc.data()._id_user_local == remoteUserId) {
        this.setCurrentChat(doc);
      }

      rooms.push(doc.data());
    });
    rooms.forEach(r => r.roomName = this.getRemoteUsername(r));
    rooms.forEach((room)=>{
      room.users.forEach(user => {
        if(user._id !== this.user_id){
          room.avatar= this.getRemoteAvatar(room)
          if(room.avatar == 'assets/imagen/Profile.svg'){
            room.avatar ='assets/imagen/ProfileN.png';
          }
        }
      });
    })
    this.rooms = rooms;

    console.log('CHAT','Chat Rooms: ', this.rooms);

    return this.doc_ref?.data();
  }

  public async setCurrentChat(document) {
    this.doc_ref = document;
    console.log('CHAT','Setting current chat', this.doc_ref, this.doc_ref.data());

    if (this.doc_ref.data().roomId != this.doc_ref.id) {
      // Updating Room inner ID

      console.log('CHAT','Updating current chat inner roomID', this.doc_ref.id, this.doc_ref);

      const docUpdateRef = doc(this.util.db, 'chatrooms', this.doc_ref.id);

      await updateDoc(docUpdateRef, {
        roomId: this.doc_ref.id
      });
    }

    this.subscribeToChanges();
  }

  private subscribeToChanges() {
    if (this.unsub) {
      this.unsub();
    }
    this.unsub = onSnapshot(doc(this.util.db, 'chatrooms', this.doc_ref.id), { includeMetadataChanges: true },
(doc) => {
      console.log('CHAT','Current data: ', doc.data());
      // alert('New message!')
      this.messages = doc.data().messages ? doc.data().messages : [];
    },
      (error) => console.log('CHAT','ERROR: ', error));
  }

  async startChatroom(localUser, remoteUser, message) {
    let chatrooms = await collection(this.util.db, 'chatrooms');

    console.log('CHAT','Local user: ', localUser);
    console.log('CHAT','Target user: ', remoteUser);

    try {
      const docRef = await addDoc(chatrooms, {
        roomId: '1',
        roomName: localUser.name + ' and ' + remoteUser.name,
        avatar: 'https://louderband-app.web.app/assets/imagen/load.gif',
        users: [
          { _id: localUser.id + '', username: localUser.name, avatar: localUser.profile_image, userData: localUser },
          { _id: remoteUser.id + '', username: remoteUser.name, avatar: remoteUser.profile_image, userData: remoteUser },
        ],
        _id_user_local: localUser.id + '',
        _id_user_remote: remoteUser.id + ''
      });

      this.doc_ref = docRef;
      console.log('CHAT',"Document written with ID: ", docRef.id);

      console.log('CHAT','Updating inner ID...');
      const docUpdateRef = doc(this.util.db, 'chatrooms', this.doc_ref.id);

      await updateDoc(docUpdateRef, {
        roomId: this.doc_ref.id
      });

      if (message) {
        this.sendMessage({ content: message }, true);
        console.log("mande un mensaje");
      }

      const chatroom: any = await this.findChatroom(this.user.id, this.user_id);
      this.roomId = chatroom.roomId;
      this.subscribeToChanges();
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  }

  private async notification(localUser, remoteUser) {
    const notification = await collection(this.util.db, 'notificaciones');
    const filterDocument = query(collection(this.util.db, "notificaciones"), where("receiver", "==", remoteUser.id + ''), where("emisor", "==", localUser.id + ''));
    const querySnapshot = await getDocs(filterDocument);
    querySnapshot.forEach((notificationDoc) => {
      // doc.data() is never undefined for query doc snapshots
    });
      if(querySnapshot.docs.length > 0) {
        const firstDoc = querySnapshot.docs[0];
        await updateDoc(doc(this.util.db, 'notificaciones', firstDoc.id), {
          readed: false,
          timestamp: new Date().getTime()
        });
      } else {
        try {
          const docNotification = await addDoc(notification, {
            emisorName: localUser.name,
            emisorAvatar: localUser.profile_image,
            emisor: localUser.id + '',
            receiver: remoteUser.id + '',
            readed: false,
            deactivate: false,
            timestamp: new Date().getTime()
          });
          this.docRefNotification = docNotification;

        } catch (e) {
          console.error("Error sending document: ", e);
        }
      }
  }

  fetchMessages(event, roomId = null) {

    let room = event ? event.detail[0].room : { 'roomId': roomId };
    let options = event ? event.detail[0].options : null;

    console.log('CHAT','Fetch messages:', room, options);

    this.openChatRoom(room);
  }

  private openChatRoom(room) {
    this.remoteUser = this.getRemoteUser(room);
    setTimeout(async () => {
      this.remoteAvatar = this.getRemoteAvatar(room);
      this.profileID = this.getIDProfile(room);
      const docRef = doc(this.util.db, "chatrooms", room.roomId);

      this.doc_ref = docRef;
      const docSnap = await getDoc(docRef);
      this.messages = docSnap.data().messages ? docSnap.data().messages : [];
      const message = this.url_message;
      if (message) {
        this.sendMessage({ content: message });
        this.url_message = null;
        this.navCtrl.navigateForward('/mensajes/usuario/' + this.user_id);
        console.log("mande un mensaje2");
      }
      this.messagesLoaded = true;
      //this.scrolltoBottom();

      this.subscribeToChanges();
    });
  }

  addMessages(reset = false) {
    // const messages = [];

    // for (let i = 0; i < 30; i++) {
    //   messages.push({
    //     _id: reset ? i : this.messages.length + i,
    //     content: `${reset ? '' : 'paginated'} message ${i + 1}`,
    //     senderId: '4321',
    //     username: 'John Doe',
    //     date: '13 November',
    //     timestamp: '10:20',
    //   });
    // }

    // return messages;
  }

  async sendMessage(message, clear = false) {
    if (clear) {
      this.messages = [
        {
          _id: this.messages.length,
          content: message.content,
          senderId: this.user.id + '',
          avatar: this.user.profile_image,
          timestamp: new Date().toString().substring(16, 21),
          date: new Date().toDateString(),
          
        },
      ];
      console.log("mande un mensaje3");
    } else {
      this.messages = [
        ...this.messages,
        {
          _id: this.messages.length,
          content: message.content,
          senderId: this.user.id + '',
          avatar: this.user.profile_image,
          timestamp: new Date().toString().substring(16, 21),
          date: new Date().toDateString(),
        },
      ];
      console.log("mande un mensaje4", this.user);
    }

    const docRef = doc(this.util.db, 'chatrooms', this.doc_ref.id);

    console.log('CHAT','Updating records to document:', this.doc_ref.id);

    await updateDoc(docRef, {
      messages: this.messages
    });

    this.notification(this.user, this.util.chatTargetUser ? this.util.chatTargetUser : { id: this.remoteUser._id });
    
    var chatroom: any = await this.findChatroom(this.user.id, this.remoteUser._id);
    chatroom.users.forEach(async userCicle => {
      if(userCicle._id === this.remoteUser._id){
        var remoteUser = await this.getProfileUser(userCicle._id );
        if(remoteUser.notification_id !== null && remoteUser.notification_id !== '' && remoteUser.notification_id !== undefined && remoteUser.allow_notifications == true){                        
          this.oneSignalCreatNoti(this.user, remoteUser.notification_id);
        }else{
          console.log("no hay notification, notification_id null")
        }   
      }
    }); 
  }

  outData2(ev) {

    if (ev && ev.blur) {
      this.showOverSearch = false;
      this.searchTop = null;
      this.helpFocus = false;
      this.searchBar.clearFilters();
    }
  }

  async getProfileUser(userId){
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      }
    };

    const response = await fetch(`https://v2.louderband.com/api/accounts/user-information/${userId}`, options);
    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }
    const data = await response.json();
    return data;
  }
  oneSignalCreatNoti(user, notification_id) {
    const body = {
      app_id: environment.ONESIGNAL_APP_ID,
      include_aliases: { onesignal_id: [notification_id] },
      target_channel: 'push',
      data: {
        foo: 'bar',
      },
      contents: {
        en: `tienes un mensaje de ${user.name}`,
        
      },
    };
    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Basic ${environment.API_KEY}`,
        'content-type': 'application/json',
      },
      body: JSON.stringify(body),
    };

    fetch('https://api.onesignal.com/notifications', options)
      .then((response) => response.json())
      .then((response) => console.log('respuesta', response))
      .catch((err) => console.error(err));
  }

  outData(ev) {
    if (ev && ev.editProfile) {
      this.navCtrl.navigateForward('mi-perfil');
    }

    if (ev && ev.focus) {
      this.showOverSearch = true;
      if (ev.search === '') {
        this.searchTop = '';
      }
      setTimeout(() => {
        this.helpFocus = true;
      }, 1800);
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login')
    }

    if (ev && ev.home) {
      let url = '/home';
      this.locationRouter.go(url);
    }

    if (ev && ev.referred) {
      let url = '/referred';
      this.navCtrl.navigateRoot(url);
    }

    if (ev && ev.old) {
      // this.navCtrl.navigateRoot('/registro')
      this.gotoOldApp(ev.view);
    }


    if (ev && ev.search) {
      console.log('CHAT',ev.search);
      this.searchTop = ev.search;

    }

    if (ev && typeof ev.isMobile === 'boolean') {
      // console.log('CHAT',ev);
      this.isMobile = ev.isMobile;
    }
    /*if (ev && ev.blur) {
      this.showOverSearch = false;
      this.searchTop = null;
      this.helpFocus = false;
      this.searchBar.clearFilters();
    }*/

  }

  gotoOldApp(view?) {
    console.log('CHAT',view);

    if (view) {
      this.navCtrl.navigateForward(view);
    } else {
      window.open('https://louderband.com/', '_self');
    }
  }

  getRemoteUser(item: any) {
    return item.users.find(u => u._id != this.currentUserId);
  }

  getRemoteAvatar(item: any) {
    const remoteUser = item.users.find(u => u._id != this.currentUserId);
    this.avatarImg = remoteUser.avatar;
    if (remoteUser && remoteUser.avatar) {
      return remoteUser.avatar;
    }
    return 'assets/imagen/Profile.svg';
  }

  hasAvatar(item: any) {
    const remoteUser = item.users.find(u => u._id != this.currentUserId);
    return remoteUser && remoteUser.avatar;
  }

  getIDProfile(item: any) {
    const remoteUser = item.users.find(u => u._id != this.currentUserId);
    if (remoteUser) {
      return remoteUser._id;
    }
    return '';
  }

  getRemoteUsername(item: any) {
    const remoteUser = item.users.find(u => u._id != this.currentUserId);
    if (remoteUser) {
      return remoteUser.username;
    }
    return 'Anonimo';
  }

  goToProfile(){
    this.navCtrl.navigateForward('/perfiles/' + this.profileID);
  }

   private scrolltoBottom(): void {
    const bottom = this.elementRef.nativeElement.querySelector('#bot');
    bottom.scrollIntoView({behavior: 'smooth'});
  }
}
